"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cachedAuthCall = void 0;
const axios_1 = __importDefault(require("axios"));
const application_host_1 = require("../common/application-host");
const interceptors_1 = require("./interceptors");
const cachedAuthCall = axios_1.default.create({
    baseURL: application_host_1.ADD_API,
    headers: {
        "Content-Type": "application/json",
        "Cache-Control": "max-age=1",
    },
});
exports.cachedAuthCall = cachedAuthCall;
//Request
cachedAuthCall.interceptors.request.use(interceptors_1.requestHeaderOnFulfilledAsync, interceptors_1.onRequestError);
// Response
cachedAuthCall.interceptors.response.use(interceptors_1.responseOnFulfilledAsync);
